// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormButtons-module__font-s-10___PKsrz {
  font-size: 10px !important;
}

.FormButtons-module__font-s-12___qI1Al {
  font-size: 12px !important;
}

.FormButtons-module__font-s-13___WFDkQ {
  font-size: 13px !important;
}

.FormButtons-module__font-s-14___lCUXY {
  font-size: 14px !important;
}

.FormButtons-module__font-s-15___yTlR_ {
  font-size: 15px !important;
}

.FormButtons-module__font-s-16___yrD4x {
  font-size: 16px !important;
}

.FormButtons-module__font-s-18___AQ7r8 {
  font-size: 18px !important;
}

.FormButtons-module__font-s-20___OBhph {
  font-size: 20px !important;
}

.FormButtons-module__font-s-22___NFa4y {
  font-size: 22px !important;
}

.FormButtons-module__font-s-28___O9zbv {
  font-size: 28px !important;
}

.FormButtons-module__font-w-400___Iw2cW {
  font-weight: 400 !important;
}

.FormButtons-module__font-w-500___ILpAE {
  font-weight: 500 !important;
}

.FormButtons-module__font-w-600___KImeB {
  font-weight: 600 !important;
}

.FormButtons-module__font-w-700___U5rsI {
  font-weight: 700 !important;
}

.FormButtons-module__p-5___HD3CM {
  padding: 5px !important;
}

.FormButtons-module__p-12___m_HSn {
  padding: 12px !important;
}

.FormButtons-module__p-16___UFdGi {
  padding: 16px !important;
}

.FormButtons-module__p-30___U_AEW {
  padding: 30px !important;
}

.FormButtons-module__p-b-0___Li5Co {
  padding-bottom: 0 !important;
}

.FormButtons-module__p-b-5___gFFjj {
  padding-bottom: 5px !important;
}

.FormButtons-module__p-b-10___jNWkN {
  padding-bottom: 10px !important;
}

.FormButtons-module__p-b-12___WjJB1 {
  padding-bottom: 12px !important;
}

.FormButtons-module__p-b-16___Ju6vn {
  padding-bottom: 16px !important;
}

.FormButtons-module__p-b-18___B0X9g {
  padding-bottom: 18px !important;
}

.FormButtons-module__p-b-20___BAp4H {
  padding-bottom: 20px !important;
}

.FormButtons-module__p-b-25___ZCIf7 {
  padding-bottom: 25px !important;
}

.FormButtons-module__p-b-30___r8or1 {
  padding-bottom: 30px !important;
}

.FormButtons-module__p-b-50___TZNFA {
  padding-bottom: 50px !important;
}

.FormButtons-module__p-t-0___VR2yt {
  padding-top: 0 !important;
}

.FormButtons-module__p-t-12___OfqfU {
  padding-top: 12px !important;
}

.FormButtons-module__p-t-16___e9R_p {
  padding-top: 16px !important;
}

.FormButtons-module__p-t-18___Bkxqt {
  padding-top: 18px !important;
}

.FormButtons-module__p-t-20___J0qlU {
  padding-top: 20px !important;
}

.FormButtons-module__p-t-30___ijcVl {
  padding-top: 30px !important;
}

.FormButtons-module__p-t-40___VOnpp {
  padding-top: 40px !important;
}

.FormButtons-module__p-t-50___lA14E {
  padding-top: 50px !important;
}

.FormButtons-module__p-l-20___kH8dD {
  padding-left: 20px !important;
}

.FormButtons-module__p-l-30___E2HLo {
  padding-left: 30px !important;
}

.FormButtons-module__p-l-40___nf8i0 {
  padding-left: 40px !important;
}

.FormButtons-module__p-r-16___clHL2 {
  padding-right: 16px !important;
}

.FormButtons-module__p-r-20___VVxFr {
  padding-right: 20px !important;
}

.FormButtons-module__p-r-30___VyWib {
  padding-right: 30px !important;
}

.FormButtons-module__p-r-50___QTSea {
  padding-right: 50px !important;
}

.FormButtons-module__p-r-60___YWJGL {
  padding-right: 60px !important;
}

.FormButtons-module__m-b-1___KFGM5 {
  margin-bottom: 1px !important;
}

.FormButtons-module__m-b-2___QacN1 {
  margin-bottom: 2px !important;
}

.FormButtons-module__m-b-6___ATfIs {
  margin-bottom: 6px !important;
}

.FormButtons-module__m-b-8___HDeOY {
  margin-bottom: 8px !important;
}

.FormButtons-module__m-b-10___dX3kC {
  margin-bottom: 10px !important;
}

.FormButtons-module__m-b-14___h2GLY {
  margin-bottom: 14px !important;
}

.FormButtons-module__m-b-16___EP1M6 {
  margin-bottom: 16px !important;
}

.FormButtons-module__m-b-20___Uwrfp {
  margin-bottom: 20px !important;
}

.FormButtons-module__m-b-22___ZTZD1 {
  margin-bottom: 22px !important;
}

.FormButtons-module__m-b-24___qgmrw {
  margin-bottom: 24px !important;
}

.FormButtons-module__m-b-30___aGerP {
  margin-bottom: 30px !important;
}

.FormButtons-module__m-b-32___bnXOC {
  margin-bottom: 32px !important;
}

.FormButtons-module__m-b-40___GTGjT {
  margin-bottom: 40px !important;
}

.FormButtons-module__m-t-2___HNoC_ {
  margin-top: 2px !important;
}

.FormButtons-module__m-t-3___duixX {
  margin-top: 3px !important;
}

.FormButtons-module__m-t-4___bRKlq {
  margin-top: 4px !important;
}

.FormButtons-module__m-t-5___vFFH_ {
  margin-top: 5px !important;
}

.FormButtons-module__m-t-8___AUI45 {
  margin-top: 8px !important;
}

.FormButtons-module__m-t-10___CJlpt {
  margin-top: 10px !important;
}

.FormButtons-module__m-t-15___PtdW7 {
  margin-top: 15px !important;
}

.FormButtons-module__m-t-16___dyD7j {
  margin-top: 16px !important;
}

.FormButtons-module__m-t-20___rzpbe {
  margin-top: 20px !important;
}

.FormButtons-module__m-t-22___BEOwV {
  margin-top: 22px !important;
}

.FormButtons-module__m-t-30___nMvrv {
  margin-top: 30px !important;
}

.FormButtons-module__m-t-32___XY9sY {
  margin-top: 32px !important;
}

.FormButtons-module__m-l-auto___Obmii {
  margin-left: auto !important;
}

.FormButtons-module__m-l-4___zbxxE {
  margin-left: 4px !important;
}

.FormButtons-module__m-l-5____S_7N {
  margin-left: 5px !important;
}

.FormButtons-module__m-l-6___vjwO4 {
  margin-left: 6px !important;
}

.FormButtons-module__m-l-8____iPRC {
  margin-left: 8px !important;
}

.FormButtons-module__m-l-10___NI5nl {
  margin-left: 10px !important;
}

.FormButtons-module__m-l-16___OfXWn {
  margin-left: 16px !important;
}

.FormButtons-module__m-l-20___uOnaU {
  margin-left: 20px !important;
}

.FormButtons-module__m-l-24___iNzO3 {
  margin-left: 24px !important;
}

.FormButtons-module__m-l-30___Y9rd5 {
  margin-left: 30px !important;
}

.FormButtons-module__m-l-35___osLwh {
  margin-left: 35px !important;
}

.FormButtons-module__m-l-40___THEwI {
  margin-left: 40px !important;
}

.FormButtons-module__m-r-8___Lw1vX {
  margin-right: 8px !important;
}

.FormButtons-module__m-r-10___XWYcl {
  margin-right: 10px !important;
}

.FormButtons-module__m-r-16___cZrwS {
  margin-right: 16px !important;
}

.FormButtons-module__m-r-20___OmLlR {
  margin-right: 20px !important;
}

.FormButtons-module__m-r-24___HbFgv {
  margin-right: 24px !important;
}

.FormButtons-module__m-r-30___kz8w8 {
  margin-right: 30px !important;
}

.FormButtons-module__m-r-40___ZFIBv {
  margin-right: 40px !important;
}

.FormButtons-module__border-r-3___F17AD {
  border-radius: 3px !important;
}

.FormButtons-module__border-r-4___F8WRU {
  border-radius: 4px !important;
}

.FormButtons-module__border-r-6___Ng7FF {
  border-radius: 6px !important;
}

.FormButtons-module__border-r-10___eDFsg {
  border-radius: 10px !important;
}

.FormButtons-module__border-r-12___bxqYr {
  border-radius: 12px !important;
}

.FormButtons-module__border-r-16___lD97c {
  border-radius: 16px !important;
}

.FormButtons-module__border-r-50____jEa1 {
  border-radius: 50% !important;
}

.FormButtons-module__primary-border___DWwE8 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.FormButtons-module__primary-border-b___VPhpe {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.FormButtons-module__primary-border-t___gteHL {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.FormButtons-module__primary-border-l___ILCkL {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.FormButtons-module__primary-border-r___p2ZkM {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.FormButtons-module__secondary-border___YxqgZ {
  border: 1px solid #637768;
}

.FormButtons-module__secondary-border-b___GAcvH {
  border-bottom: 1px solid #637768;
}

.FormButtons-module__secondary-border-t___DjXHM {
  border-top: 1px solid #637768;
}

.FormButtons-module__secondary-border-l___GE1IU {
  border-left: 1px solid #637768;
}

.FormButtons-module__secondary-border-r___l77lr {
  border-right: 1px solid #637768;
}

.FormButtons-module__gap-0___I5t6F {
  gap: 0 !important;
}

.FormButtons-module__gap-2___bW4VF {
  gap: 2px !important;
}

.FormButtons-module__gap-4___NWVXo {
  gap: 4px !important;
}

.FormButtons-module__gap-5____tFWp {
  gap: 5px !important;
}

.FormButtons-module__gap-6___jzEWp {
  gap: 6px !important;
}

.FormButtons-module__gap-8___x_h9D {
  gap: 8px !important;
}

.FormButtons-module__gap-10___LWvAz {
  gap: 10px !important;
}

.FormButtons-module__gap-12___1qKHF {
  gap: 12px !important;
}

.FormButtons-module__gap-14___N8H_c {
  gap: 14px !important;
}

.FormButtons-module__gap-16___hrBH8 {
  gap: 16px !important;
}

.FormButtons-module__gap-18___ABUQe {
  gap: 18px !important;
}

.FormButtons-module__gap-20___pPrwh {
  gap: 20px !important;
}

.FormButtons-module__gap-24___GBlHu {
  gap: 24px !important;
}

.FormButtons-module__gap-26___lviEj {
  gap: 26px !important;
}

.FormButtons-module__gap-30___klTp8 {
  gap: 30px !important;
}

.FormButtons-module__gap-32___TmGeq {
  gap: 32px !important;
}

.FormButtons-module__gap-40___md8Mq {
  gap: 40px !important;
}

.FormButtons-module__gap-50___uFyX3 {
  gap: 50px !important;
}

.FormButtons-module__flex-1___IzJi_ {
  flex: 1;
}

.FormButtons-module__flex-none___wqUWP {
  flex: none !important;
}

.FormButtons-module__flex-column___RPprf {
  display: flex;
  flex-direction: column !important;
}

.FormButtons-module__flex-row___Qrlqd {
  display: flex;
  flex-direction: row !important;
}

.FormButtons-module__vertically-centered___hTqMK {
  display: flex;
  align-items: center !important;
}

.FormButtons-module__horizontally-centered___Ieili {
  display: flex;
  justify-content: center !important;
}

.FormButtons-module__horizontally-end___WH69L {
  display: flex;
  justify-content: end !important;
}

.FormButtons-module__vertically-start___eZ8Kv {
  display: flex;
  align-items: start !important;
}

.FormButtons-module__space-between___ZCAYt {
  display: flex;
  justify-content: space-between !important;
}

.FormButtons-module__flex-wrap___otuXm {
  flex-wrap: wrap !important;
}

.FormButtons-module__height-100___w2S4x {
  height: 100%;
}

.FormButtons-module__width-50___JShRP {
  width: 50% !important;
}

.FormButtons-module__width-100___JijEA {
  width: 100%;
}

.FormButtons-module__cursor-pointer___HeUkM {
  cursor: pointer;
}

.FormButtons-module__cursor-not-allowed___IHd6g {
  cursor: not-allowed !important;
}

.FormButtons-module__absolute-centered___mmV1Y {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.FormButtons-module__absolute___SZWSS {
  position: absolute;
}

.FormButtons-module__relative___WzH8N {
  position: relative;
}

.FormButtons-module__fixed___jdshr {
  position: fixed;
}

.FormButtons-module__visible___bS5Sa {
  opacity: 1;
}

.FormButtons-module__invisible___nTFlx {
  opacity: 0;
}

.FormButtons-module__col-90___WLNml {
  width: 90% !important;
}

.FormButtons-module__col-auto___pXyoL {
  width: auto !important;
}

.FormButtons-module__medical-tabs___LLFAD {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.FormButtons-module__medical-table-new___VfTEq {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.FormButtons-module__medical-table-new___VfTEq:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.FormButtons-module__medical-table-new___VfTEq::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.FormButtons-module__medical-table-new___VfTEq::-webkit-scrollbar-track {
  display: none;
}
.FormButtons-module__medical-table-new___VfTEq.FormButtons-module__no-pagination___Gac1c {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.FormButtons-module__medical-table-new___VfTEq.FormButtons-module__no-pagination___Gac1c:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.FormButtons-module__medical-table-new___VfTEq.FormButtons-module__no-pagination___Gac1c::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.FormButtons-module__medical-table-new___VfTEq.FormButtons-module__no-pagination___Gac1c::-webkit-scrollbar-track {
  display: none;
}

.FormButtons-module__medical-table-empty___FGW1u {
  padding: 14px 40px !important;
}

.FormButtons-module__icon-btn___eG_Jx {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.FormButtons-module__search-icon___t3pg1 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.FormButtons-module__disable-select___Ke6ZC {
  user-select: none;
}

.FormButtons-module__break-word___f8ePO {
  word-break: break-word;
}

.FormButtons-module__popup-clear-btn___twhK1 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.FormButtons-module__scroll-m-b-20___FHifw {
  scroll-margin-bottom: 20px;
}

.FormButtons-module__iconButton___s6el3 {
  justify-content: end;
  flex-direction: row;
  width: auto;
}
.FormButtons-module__iconButton___s6el3 > span {
  font-size: 16px !important;
}

.FormButtons-module__sectionIconButton___q2sfh {
  padding: 0;
  min-width: auto !important;
}
.FormButtons-module__sectionIconButton___q2sfh > img {
  width: 18px;
  height: 18px;
}
.FormButtons-module__sectionIconButton___q2sfh > span {
  font-size: 14px !important;
}

.FormButtons-module__buttonsWrapper____4nZ9 {
  display: flex;
}
.FormButtons-module__buttonsWrapper____4nZ9.FormButtons-module__small___FYPpm {
  height: 32px;
}
.FormButtons-module__buttonsWrapper____4nZ9 .FormButtons-module__button___DYIn7 > span {
  font-size: 14px !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/buttons/FormButtons/FormButtons.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;AA8pBF;AA5pBE;EACE,0BAAA;AA8pBJ;;AA1pBA;EACE,UAAA;EACA,0BAAA;AA6pBF;AA3pBE;EACE,WAAA;EACA,YAAA;AA6pBJ;AA1pBE;EACE,0BAAA;AA4pBJ;;AAxpBA;EACE,aAAA;AA2pBF;AAzpBE;EACE,YAAA;AA2pBJ;AAvpBI;EACE,0BAAA;AAypBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.iconButton {\n  justify-content: end;\n  flex-direction: row;\n  width: auto;\n\n  & > span {\n    font-size: 16px !important;\n  }\n}\n\n.sectionIconButton {\n  padding: 0;\n  min-width: auto !important;\n\n  & > img {\n    width: 18px;\n    height: 18px;\n  }\n\n  & > span {\n    font-size: 14px !important;\n  }\n}\n\n.buttonsWrapper {\n  display: flex;\n\n  &.small {\n    height: 32px;\n  }\n\n  .button {\n    & > span {\n      font-size: 14px !important;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `FormButtons-module__font-s-10___PKsrz`,
	"fontS12": `FormButtons-module__font-s-12___qI1Al`,
	"fontS13": `FormButtons-module__font-s-13___WFDkQ`,
	"fontS14": `FormButtons-module__font-s-14___lCUXY`,
	"fontS15": `FormButtons-module__font-s-15___yTlR_`,
	"fontS16": `FormButtons-module__font-s-16___yrD4x`,
	"fontS18": `FormButtons-module__font-s-18___AQ7r8`,
	"fontS20": `FormButtons-module__font-s-20___OBhph`,
	"fontS22": `FormButtons-module__font-s-22___NFa4y`,
	"fontS28": `FormButtons-module__font-s-28___O9zbv`,
	"fontW400": `FormButtons-module__font-w-400___Iw2cW`,
	"fontW500": `FormButtons-module__font-w-500___ILpAE`,
	"fontW600": `FormButtons-module__font-w-600___KImeB`,
	"fontW700": `FormButtons-module__font-w-700___U5rsI`,
	"p5": `FormButtons-module__p-5___HD3CM`,
	"p12": `FormButtons-module__p-12___m_HSn`,
	"p16": `FormButtons-module__p-16___UFdGi`,
	"p30": `FormButtons-module__p-30___U_AEW`,
	"pB0": `FormButtons-module__p-b-0___Li5Co`,
	"pB5": `FormButtons-module__p-b-5___gFFjj`,
	"pB10": `FormButtons-module__p-b-10___jNWkN`,
	"pB12": `FormButtons-module__p-b-12___WjJB1`,
	"pB16": `FormButtons-module__p-b-16___Ju6vn`,
	"pB18": `FormButtons-module__p-b-18___B0X9g`,
	"pB20": `FormButtons-module__p-b-20___BAp4H`,
	"pB25": `FormButtons-module__p-b-25___ZCIf7`,
	"pB30": `FormButtons-module__p-b-30___r8or1`,
	"pB50": `FormButtons-module__p-b-50___TZNFA`,
	"pT0": `FormButtons-module__p-t-0___VR2yt`,
	"pT12": `FormButtons-module__p-t-12___OfqfU`,
	"pT16": `FormButtons-module__p-t-16___e9R_p`,
	"pT18": `FormButtons-module__p-t-18___Bkxqt`,
	"pT20": `FormButtons-module__p-t-20___J0qlU`,
	"pT30": `FormButtons-module__p-t-30___ijcVl`,
	"pT40": `FormButtons-module__p-t-40___VOnpp`,
	"pT50": `FormButtons-module__p-t-50___lA14E`,
	"pL20": `FormButtons-module__p-l-20___kH8dD`,
	"pL30": `FormButtons-module__p-l-30___E2HLo`,
	"pL40": `FormButtons-module__p-l-40___nf8i0`,
	"pR16": `FormButtons-module__p-r-16___clHL2`,
	"pR20": `FormButtons-module__p-r-20___VVxFr`,
	"pR30": `FormButtons-module__p-r-30___VyWib`,
	"pR50": `FormButtons-module__p-r-50___QTSea`,
	"pR60": `FormButtons-module__p-r-60___YWJGL`,
	"mB1": `FormButtons-module__m-b-1___KFGM5`,
	"mB2": `FormButtons-module__m-b-2___QacN1`,
	"mB6": `FormButtons-module__m-b-6___ATfIs`,
	"mB8": `FormButtons-module__m-b-8___HDeOY`,
	"mB10": `FormButtons-module__m-b-10___dX3kC`,
	"mB14": `FormButtons-module__m-b-14___h2GLY`,
	"mB16": `FormButtons-module__m-b-16___EP1M6`,
	"mB20": `FormButtons-module__m-b-20___Uwrfp`,
	"mB22": `FormButtons-module__m-b-22___ZTZD1`,
	"mB24": `FormButtons-module__m-b-24___qgmrw`,
	"mB30": `FormButtons-module__m-b-30___aGerP`,
	"mB32": `FormButtons-module__m-b-32___bnXOC`,
	"mB40": `FormButtons-module__m-b-40___GTGjT`,
	"mT2": `FormButtons-module__m-t-2___HNoC_`,
	"mT3": `FormButtons-module__m-t-3___duixX`,
	"mT4": `FormButtons-module__m-t-4___bRKlq`,
	"mT5": `FormButtons-module__m-t-5___vFFH_`,
	"mT8": `FormButtons-module__m-t-8___AUI45`,
	"mT10": `FormButtons-module__m-t-10___CJlpt`,
	"mT15": `FormButtons-module__m-t-15___PtdW7`,
	"mT16": `FormButtons-module__m-t-16___dyD7j`,
	"mT20": `FormButtons-module__m-t-20___rzpbe`,
	"mT22": `FormButtons-module__m-t-22___BEOwV`,
	"mT30": `FormButtons-module__m-t-30___nMvrv`,
	"mT32": `FormButtons-module__m-t-32___XY9sY`,
	"mLAuto": `FormButtons-module__m-l-auto___Obmii`,
	"mL4": `FormButtons-module__m-l-4___zbxxE`,
	"mL5": `FormButtons-module__m-l-5____S_7N`,
	"mL6": `FormButtons-module__m-l-6___vjwO4`,
	"mL8": `FormButtons-module__m-l-8____iPRC`,
	"mL10": `FormButtons-module__m-l-10___NI5nl`,
	"mL16": `FormButtons-module__m-l-16___OfXWn`,
	"mL20": `FormButtons-module__m-l-20___uOnaU`,
	"mL24": `FormButtons-module__m-l-24___iNzO3`,
	"mL30": `FormButtons-module__m-l-30___Y9rd5`,
	"mL35": `FormButtons-module__m-l-35___osLwh`,
	"mL40": `FormButtons-module__m-l-40___THEwI`,
	"mR8": `FormButtons-module__m-r-8___Lw1vX`,
	"mR10": `FormButtons-module__m-r-10___XWYcl`,
	"mR16": `FormButtons-module__m-r-16___cZrwS`,
	"mR20": `FormButtons-module__m-r-20___OmLlR`,
	"mR24": `FormButtons-module__m-r-24___HbFgv`,
	"mR30": `FormButtons-module__m-r-30___kz8w8`,
	"mR40": `FormButtons-module__m-r-40___ZFIBv`,
	"borderR3": `FormButtons-module__border-r-3___F17AD`,
	"borderR4": `FormButtons-module__border-r-4___F8WRU`,
	"borderR6": `FormButtons-module__border-r-6___Ng7FF`,
	"borderR10": `FormButtons-module__border-r-10___eDFsg`,
	"borderR12": `FormButtons-module__border-r-12___bxqYr`,
	"borderR16": `FormButtons-module__border-r-16___lD97c`,
	"borderR50": `FormButtons-module__border-r-50____jEa1`,
	"primaryBorder": `FormButtons-module__primary-border___DWwE8`,
	"primaryBorderB": `FormButtons-module__primary-border-b___VPhpe`,
	"primaryBorderT": `FormButtons-module__primary-border-t___gteHL`,
	"primaryBorderL": `FormButtons-module__primary-border-l___ILCkL`,
	"primaryBorderR": `FormButtons-module__primary-border-r___p2ZkM`,
	"secondaryBorder": `FormButtons-module__secondary-border___YxqgZ`,
	"secondaryBorderB": `FormButtons-module__secondary-border-b___GAcvH`,
	"secondaryBorderT": `FormButtons-module__secondary-border-t___DjXHM`,
	"secondaryBorderL": `FormButtons-module__secondary-border-l___GE1IU`,
	"secondaryBorderR": `FormButtons-module__secondary-border-r___l77lr`,
	"gap0": `FormButtons-module__gap-0___I5t6F`,
	"gap2": `FormButtons-module__gap-2___bW4VF`,
	"gap4": `FormButtons-module__gap-4___NWVXo`,
	"gap5": `FormButtons-module__gap-5____tFWp`,
	"gap6": `FormButtons-module__gap-6___jzEWp`,
	"gap8": `FormButtons-module__gap-8___x_h9D`,
	"gap10": `FormButtons-module__gap-10___LWvAz`,
	"gap12": `FormButtons-module__gap-12___1qKHF`,
	"gap14": `FormButtons-module__gap-14___N8H_c`,
	"gap16": `FormButtons-module__gap-16___hrBH8`,
	"gap18": `FormButtons-module__gap-18___ABUQe`,
	"gap20": `FormButtons-module__gap-20___pPrwh`,
	"gap24": `FormButtons-module__gap-24___GBlHu`,
	"gap26": `FormButtons-module__gap-26___lviEj`,
	"gap30": `FormButtons-module__gap-30___klTp8`,
	"gap32": `FormButtons-module__gap-32___TmGeq`,
	"gap40": `FormButtons-module__gap-40___md8Mq`,
	"gap50": `FormButtons-module__gap-50___uFyX3`,
	"flex1": `FormButtons-module__flex-1___IzJi_`,
	"flexNone": `FormButtons-module__flex-none___wqUWP`,
	"flexColumn": `FormButtons-module__flex-column___RPprf`,
	"flexRow": `FormButtons-module__flex-row___Qrlqd`,
	"verticallyCentered": `FormButtons-module__vertically-centered___hTqMK`,
	"horizontallyCentered": `FormButtons-module__horizontally-centered___Ieili`,
	"horizontallyEnd": `FormButtons-module__horizontally-end___WH69L`,
	"verticallyStart": `FormButtons-module__vertically-start___eZ8Kv`,
	"spaceBetween": `FormButtons-module__space-between___ZCAYt`,
	"flexWrap": `FormButtons-module__flex-wrap___otuXm`,
	"height100": `FormButtons-module__height-100___w2S4x`,
	"width50": `FormButtons-module__width-50___JShRP`,
	"width100": `FormButtons-module__width-100___JijEA`,
	"cursorPointer": `FormButtons-module__cursor-pointer___HeUkM`,
	"cursorNotAllowed": `FormButtons-module__cursor-not-allowed___IHd6g`,
	"absoluteCentered": `FormButtons-module__absolute-centered___mmV1Y`,
	"absolute": `FormButtons-module__absolute___SZWSS`,
	"relative": `FormButtons-module__relative___WzH8N`,
	"fixed": `FormButtons-module__fixed___jdshr`,
	"visible": `FormButtons-module__visible___bS5Sa`,
	"invisible": `FormButtons-module__invisible___nTFlx`,
	"col90": `FormButtons-module__col-90___WLNml`,
	"colAuto": `FormButtons-module__col-auto___pXyoL`,
	"medicalTabs": `FormButtons-module__medical-tabs___LLFAD`,
	"medicalTableNew": `FormButtons-module__medical-table-new___VfTEq`,
	"noPagination": `FormButtons-module__no-pagination___Gac1c`,
	"medicalTableEmpty": `FormButtons-module__medical-table-empty___FGW1u`,
	"iconBtn": `FormButtons-module__icon-btn___eG_Jx`,
	"searchIcon": `FormButtons-module__search-icon___t3pg1`,
	"disableSelect": `FormButtons-module__disable-select___Ke6ZC`,
	"breakWord": `FormButtons-module__break-word___f8ePO`,
	"popupClearBtn": `FormButtons-module__popup-clear-btn___twhK1`,
	"scrollMB20": `FormButtons-module__scroll-m-b-20___FHifw`,
	"iconButton": `FormButtons-module__iconButton___s6el3`,
	"sectionIconButton": `FormButtons-module__sectionIconButton___q2sfh`,
	"buttonsWrapper": `FormButtons-module__buttonsWrapper____4nZ9`,
	"small": `FormButtons-module__small___FYPpm`,
	"button": `FormButtons-module__button___DYIn7`
};
module.exports = ___CSS_LOADER_EXPORT___;
